import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { PaymentProvider } from '../paymentprovider.model';
import { PaymentproviderService } from '../paymentprovider.service';

declare let $: any;

@Component({
  selector: 'app-paymentproviderform',
  templateUrl: './paymentproviderform.component.html',
  styleUrls: ['./paymentproviderform.component.css']
})
export class PaymentproviderformComponent implements OnInit, AfterViewInit {

  paymentProvider: PaymentProvider = {} as PaymentProvider;
  updateMode = false;
  imagPath: any;
  files = [];
  active = true;
  spinnerOverlay = false;
  lang: any;
  selectedType: number = 1;

  config = {
    placeholder: 'aaaaa',
    tabsize: 2,
    height: 200,
    dialogsInBody: true,
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']]
    ],
    fontNames: ['Helvetica', 'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times']
  }

  constructor(private router: Router,
    private service: PaymentproviderService,
    private globle: Globle,
    private snackBar: MatSnackBar,
    private activateRoute: ActivatedRoute,
    private translate: TranslateService,
    private localStorage: LocalStorageService) { }

  ngOnInit(): void {
    this.imagPath = this.globle.imgPath;
    this.lang = this.localStorage.retrieve("lang");
    this.getUrlParam();
  }

  ngAfterViewInit(): void {
    this.loaddropify();
  }

  loaddropify() {
    var drEvent = $('.dropify').dropify();

    drEvent.on('dropify.afterClear', () => {
      this.paymentProvider.imgUrl = null;
      this.files = [];
    });

  }

  getUrlParam() {
    this.activateRoute.paramMap.subscribe(param => {
      if (param.get("id") != null) {
        this.paymentProvider.id = +param.get("id")!;
        this.updateMode = true;
        this.getById();
      }
    })
  }

  getById() {
    this.spinnerOverlay = true;
    this.service.getById(this.paymentProvider.id).subscribe(data => {
      this.paymentProvider = data
      this.spinnerOverlay = false;
      this.paymentProvider.status == 1 ? this.active = true : this.active = false;

      this.fillDropifyImage(this.paymentProvider.imgUrl);

    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
    })
  }

  back() {
    this.router.navigate(["./master/cards/paymentproviders"]);
  }

  submit() {

    this.spinnerOverlay = true;
    this.active ? this.paymentProvider.status = 1 : this.paymentProvider.status = 0;
    if (this.files.length > 0) {
      this.uploadImage();
    }
    else {
      !this.updateMode ? this.create() : this.update();
    }
  }

  create() {

    this.service.Create(this.paymentProvider).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("createdSuccessfully"), 'snackBarSuccess');
      this.back();
    },
      error => {
        console.log(error);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }

        this.spinnerOverlay = false;
      })
  }

  update() {

    this.service.Update(this.paymentProvider).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.back();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }

      })
  }

  onSelectImage(files: any) {
    this.files = files.target.files;
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass

    });
  }

  uploadImage() {

    let fileToUpload = <File>this.files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    this.service.upload(formData).subscribe(data => {
      this.paymentProvider.imgUrl = this.imagPath + data["dbPath"];
      !this.updateMode ? this.create() : this.update();
    }, error => {
      console.log(error);
      this.openSnackBar(error.error.message, 'snackBarError');
      this.spinnerOverlay = false;
    });
  }

  fillDropifyImage(imgUrl: any) {
    var drEvent = $('.dropify').dropify(
      {
        defaultFile: imgUrl
      });
    drEvent = drEvent.data('dropify');
    drEvent.resetPreview();
    //drEvent.clearElement();
    drEvent.settings.defaultFile = imgUrl;
    drEvent.destroy();
    drEvent.init();
  }

}
